import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  create_candidate_profession_data_action,
  delete_candidate_profession_by_id_data_action,
  get_candidate_all_professional_data_action,
  get_candidate_profession_by_id_data_action,
  update_candidate_profession_by_id_data_action,
} from "../../../../redux/_actions/candidate/candidate.actions";
import { convertDate } from "../../../../_helpers/dateFormatter";

import {
  COMPANY_INDUSTRY_CHOICES,
  EMPLOYMENT_TYPE,
  professionFormSchema,
} from "../constants";

function useProfessionalInformation(props) {
  const [allProfessionalData, setAllProfessionalData] = useState([]);
  const [professionFormData, setProfessionFormData] = useState({});
  const [loadingprofession, setLoadingProfession] = useState(false);
  const [professionFormDataLoading, setProfessionFormDataLoading] = useState(
    {}
  );
  const [editProfessionItemId, setEditProfessionItemId] = useState(null);
  const [professionStartDate, setProfessionStartDate] = useState();
  const [professionEndDate, setProfessionEndDate] = useState();
  const [newProfessionAdded, setNewProfessionAdded] = useState(false);
  const [companyIndustry, setCompanyIndustry] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [checked, setChecked] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);

  const dispatch = useDispatch();

  //get data from redux
  const { userProfessionalData } = useSelector(
    (state) => state.get_candidate_all_professional_data_reducer
  );

  const { userProfessionByIdData } = useSelector(
    (state) => state.get_candidate_profession_by_id_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (userProfessionalData?.data) {
      setAllProfessionalData(userProfessionalData?.data);
    }
  }, [userProfessionalData]);

  useEffect(() => {
    if (userProfessionByIdData?.data) {
      let data = userProfessionByIdData?.data;
      data["skills"] = data["skill_names"] && data["skill_names"];
      data["state"] = data["state_name"] && data["state_name"];
      data["city"] = data["city_name"] && data["city_name"];
      data["country"] = data["country_name"] && data["country_name"];
      data["company"] = data["company_name"] && data["company_name"];
      setProfessionStartDate(data?.start_date);
      setProfessionEndDate(data?.end_date);
      setSkillsTagsAdded(data?.skills);
      setProfessionFormData(data);
    }
  }, [userProfessionByIdData]);

  //set map values for drop downs
  useEffect(() => {
    setCompanyIndustry(COMPANY_INDUSTRY_CHOICES);
    setEmploymentType(EMPLOYMENT_TYPE);
  }, []);

  const callApi = async () => {
    setLoadingProfession(true);
    await dispatch(get_candidate_all_professional_data_action());
    setLoadingProfession(false);
  };

  const callProfessionApi = async (id) => {
    setProfessionFormDataLoading(true);
    await dispatch(get_candidate_profession_by_id_data_action(id));
    setProfessionFormDataLoading(false);
  };

  const onProfessionFormDataChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = professionFormData;

    // set data values
    if (name === "start_date") {
      value = convertDate(value);
      setProfessionStartDate(value);
    }
    if (name === "end_date") {
      value = convertDate(value);
      setProfessionEndDate(value);
    }
    data[name] = value;
    setProfessionFormData(data);
  };

  // submit experience
  const onSubmitForm = async () => {
    if (professionFormData?.id) {
      await dispatch(
        update_candidate_profession_by_id_data_action(
          professionFormData,
          professionFormData.id
        )
      );
    } else {
      await dispatch(
        create_candidate_profession_data_action(professionFormData)
      );
    }
    await dispatch(get_candidate_all_professional_data_action());
    setProfessionFormData({});
    setEditProfessionItemId(null);
    setNewProfessionAdded(false);
  };

  const onEditProfessionItemClick = (id) => {
    setEditProfessionItemId(id);
    callProfessionApi(id);
  };

  const onEditProfessionCancelClick = () => {
    setEditProfessionItemId(null);
    setNewProfessionAdded(false);
    setSkillsTagsAdded([]);
  };

  const onAddNewProfessionClick = () => {
    let data = allProfessionalData;
    setNewProfessionAdded(true);
    setProfessionEndDate(null);
    setProfessionStartDate(null);
    setSkillsTagsAdded([]);
    setProfessionFormData({ ...professionFormSchema });
    data.push({ ...professionFormSchema });
    setAllProfessionalData(data);
  };

  const deleteUserExperience = async (id) => {
    if (id) {
      await dispatch(delete_candidate_profession_by_id_data_action(id));
      setLoadingProfession(true);
      await dispatch(get_candidate_all_professional_data_action());
      setLoadingProfession(false);
    }
  };

  const onCurrentlyWorking = () => {
    let data = professionFormData;
    data["currently_working_here"] = !checked;
    setChecked(!checked);
    setProfessionFormData(data);
  };

  // delete skills tags
  const onKeywordsTagsDelete = async (tag) => {
    let data = professionFormData;
    let skills = skillsTagsAdded.filter((item) => item.toLowerCase() !== tag);
    setSkillsTagsAdded(skills);
    data["skills"] = skills;
    setProfessionFormData(data);
  };

  // add new skills tags
  const onKeywordsTagsAddition = (tag) => {
    let tagNew = tag.toLowerCase();
    let data = {...professionFormData};
    let skills = [...skillsTagsAdded];
    if (skills.indexOf(tagNew) === -1) {
      skills=[...skills, tagNew]
    }
    setSkillsTagsAdded(skills);
    data["skills"] = skills;
    setProfessionFormData(data);
  };

  // onlocation change
  const onLocationChange = (name, value) => {
    let data = professionFormData;

    if (name === "country") {
      data["state"] = "";
    }

    if (name === "state") {
      data["city"] = "";
    }
    data[name] = value;
    setProfessionFormData(data);
  };
  
  const cancelNewProfessional = () => {
    let data = allProfessionalData;
    setNewProfessionAdded(false);
    data.pop({ ...professionFormSchema });
    setAllProfessionalData(data);
  };

  return {
    allProfessionalData,
    loadingprofession,
    professionFormData,
    professionFormDataLoading,
    editProfessionItemId,
    professionEndDate,
    professionStartDate,
    newProfessionAdded,
    companyIndustry,
    employmentType,
    skillsTagsAdded,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onCurrentlyWorking,
    onProfessionFormDataChange,
    onEditProfessionItemClick,
    onEditProfessionCancelClick,
    onAddNewProfessionClick,
    onSubmitForm,
    deleteUserExperience,
    onLocationChange,
    cancelNewProfessional
  };
}
export default useProfessionalInformation;
